// import enterpriseQt from '../components/enterpriseQt/enterpriseQtList.vue'
// import viewEenterpriseQt from '../components/enterpriseQt/viewEenterpriseQt.vue'

export default [
    { 
        path: 'enterpriseQt/enterpriseQtList', 
        component: resolve => require(['@/components/enterpriseQt/enterpriseQtList'],resolve),
        name:'EnterpriseQtList',
        meta:{
            id:'845',
            node:'enterpriseQt',
            url:'enterpriseQtList',
        }
    },
    { 
        path: 'enterpriseQt/viewEenterpriseQt', 
        component: resolve => require(['@/components/enterpriseQt/viewEenterpriseQt'],resolve),
        name:'ViewEnterpriseQt',
        meta:{
            id:'846',
            node:'enterpriseQt',
            url:'viewEenterpriseQt',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/enterpriseQt.js